import { useHistory } from 'react-router-dom'

import { makeStyles, Paper } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import useTranslate from '../../../i18n/useTranslate'
import { ButtonView } from '../../../control/button/button'

interface Props {
    id: number
    nameTH: string
    nameEN: string
    recName: string
}

const Item: React.FC<Props> = ({ id, nameTH, nameEN, recName }) => {
    const translate = useTranslate()
    const classes = useStyles()
    const history = useHistory()

    const onEdit = () => {
        history.push(`/settingREC/${id}/edit`)
    }

    return (
        <Paper className={classes.paperSection} variant="outlined">
            <Grid container spacing={2} alignItems="center">
                <Grid container item xs={12} sm={12} md={2} lg={2} alignItems="center">
                    <ButtonView className={classes.btnEdit} onClick={onEdit}>
                        {translate.get('BUTTON.EDIT')}
                    </ButtonView>
                </Grid>
                <Grid container item xs={12} sm={12} md={4} lg={4} alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.name} noWrap>
                            {translate.get('UM.SETTINGREC.SEARCH.NAMETH')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{nameTH}</Typography>
                    </Grid>
                </Grid>

                <Grid container item xs={12} sm={12} md={4} lg={4} alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.name} noWrap>
                            {translate.get('UM.SETTINGREC.SEARCH.NAMEEN')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{nameEN}</Typography>
                    </Grid>
                </Grid>

                <Grid container item xs={12} sm={12} md={2} lg={2} alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.name} noWrap>
                            {translate.get('UM.SETTINGREC.SEARCH.RECNAME')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{recName}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    )
}

const useStyles = makeStyles((theme) => ({
    paperSection: {
        alignItems: 'center',
        padding: theme.spacing(3),
        marginBottom: '10px',
        transition: '0.3s',
        '&:hover': {
            border: `1px solid ${theme.palette.primary.main}`,
        },
    },
    icon: {
        marginRight: theme.spacing(1),
        width: 40,
        height: 40,
        backgroundColor: '#ece9e9',
        transition: '0.3s',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
        },
    },
    name: {
        // marginLeft: theme.spacing(1),
        fontWeight: 'bold',
    },
    btnEdit: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
        height: '44px',
        marginRight: '1px',
    },
    multiLineEllipsis: {
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
    },
}))

export default Item
